import React from 'react'
import useLatestNewsQuery from '../hooks/use-latest-news-query'
import { GatsbyImage } from 'gatsby-plugin-image'
import Link from '../utils/link'
import parse from 'html-react-parser'
import { Fade } from 'react-reveal'

const LatestNews = ({ title }) => {
  const { allWpPost } = useLatestNewsQuery()

  return (
    <section className='latest-news'>
      <div className='latest-news__inner'>
        <div className='latest-news__heading'>
          { title && <h3>{parse(title)}</h3> }
          <Link to='/blog' className='btn btn-border-powder'>View All</Link>
        </div>
        <div className='latest-news__items'>
          { allWpPost?.nodes.map(el => (
            <div key={ el.id } className='blog__item'>
              <Fade bottom distance='40px'>
                <>
                <div className='blog__image'>
                  <Link to={ `/blog/${el.slug}`}>
                    { el.featuredImage?.node.localFile && <GatsbyImage image={ el.featuredImage.node.localFile.childImageSharp.gatsbyImageData } alt=''/> }
                  </Link>
                </div>
                <div className='blog__content'>
                  { el.title && <h4><Link to={ `/blog/${el.slug}`}>{ el.title }</Link></h4> }
                  <div className='blog__cate'>
                    { el.date && <p>{ el.date }</p> }
                    { el.categories?.nodes?.length && <span className='btn btn-border-powder'><Link to={`/blog?category=${el.categories.nodes[0].slug}`}>{ el.categories.nodes[0].name }</Link></span> }
                  </div>
                </div>
                </>
              </Fade>
            </div>
          )) }
        </div>
      </div>
    </section>
  )
}

export default LatestNews